import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { useOrganizationContext } from '../../../contexts/OrganizationProvider.js';
import { useTranslation } from '../../../locales/i18n.js';
import '@cheetahdigital/console-kit-cx';
import '../../../node_modules/classnames/index.js';
import Tooltip from '../../../shared/components/Tooltip/index.js';
import 'react-dom';
import Layout from '../../../shared/layout/Layout/index.js';
import Row from '../../../shared/layout/Row/index.js';
import Column from '../../../shared/layout/Column/index.js';
import styles from './index.module.scss.js';

var BusinessunitDropdownItem = function (_a) {
    var onChange = _a.onChange;
    var t = useTranslation()[0];
    var _b = useOrganizationContext(), organization = _b.organization, _c = _b.organizations, organizations = _c === void 0 ? [] : _c;
    var isAllowChangeBu = organizations.length > 1 ||
        (!!organizations.length && organizations.every(function (org) { return !(org === null || org === void 0 ? void 0 : org.selected); }));
    var handleChangeBusinessUnit = useCallback(function (e) {
        e.preventDefault();
        var outside = document.querySelector("body");
        outside === null || outside === void 0 ? void 0 : outside.click();
        onChange();
    }, [onChange]);
    return (jsx(Layout, __assign({ className: styles.changeBusinessUnit }, { children: jsxs(Row, __assign({ isGapless: true }, { children: [jsx(Column, __assign({ isGapless: true, className: styles.info }, { children: jsx("div", __assign({ className: styles.info }, { children: jsx(Tooltip, __assign({ content: organization.buName, position: "bottom center", isGapless: true }, { children: jsx("div", __assign({ className: styles.ellipsis }, { children: jsx("b", { children: organization.buName }, void 0) }), void 0) }), void 0) }), void 0) }), void 0), isAllowChangeBu && (jsx(Column, __assign({ isGapless: true, isNarrow: true, className: styles.link, isRightAligned: true }, { children: jsx("a", __assign({ href: "#", onClick: handleChangeBusinessUnit }, { children: t("change") }), void 0) }), void 0))] }), void 0) }), void 0));
};

export { BusinessunitDropdownItem as default };
